import Link from 'next/link';
import React, { FC } from 'react';
import { settingPage } from '../../utils/types';

type Props = {
  pages: settingPage[];
  selectedPage: settingPage | undefined;
};

const SettingsSidebar: FC<Props> = ({ pages, selectedPage }) => {
  return (
    <div className="flex flex-col">
      {pages.map((item) => (
        <Link key={item.name} href={item.href}>
          <a
            className={`bg-transparent hover:bg-light-grey text-black font-semibold py-4 px-4 rounded ${
              selectedPage?.key === item.key
                ? 'bg-gray-300 hover:bg-gray-300'
                : ''
            }`}
          >
            {item.name}
          </a>
        </Link>
      ))}
    </div>
  );
};

export default SettingsSidebar;
